export default {
  FETCH_RETAILER_REPORTS_REQUEST: 'FETCH_RETAILER_REPORTS_REQUEST',
  FETCH_RETAILER_REPORTS_SUCCESS: 'FETCH_RETAILER_REPORTS_SUCCESS',
  FETCH_RETAILER_REPORTS_FAILURE: 'FETCH_RETAILER_REPORTS_FAILURE',

  CLEAR_RETAILER_REPORTS: 'CLEAR_RETAILER_REPORTS',

  DOWNLOAD_RETAILER_REPORT_REQUEST: 'DOWNLOAD_RETAILER_REPORT_REQUEST',
  DOWNLOAD_RETAILER_REPORT_SUCCESS: 'DOWNLOAD_RETAILER_REPORT_SUCCESS',
  DOWNLOAD_RETAILER_REPORT_FAILURE: 'DOWNLOAD_RETAILER_REPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/actions/action-types.js